import classNames from 'classnames';
import React__default, { Component } from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "@supports (display:grid){.BXH2w{display:grid}}.BXH2w{width:100%}.DfSjv{color:var(--ricos-text-color-low);font-size:14px;line-height:1.5}[dir] .DfSjv{margin-top:36px}";
var styles = {"selectionList":"BXH2w","selectionSubText":"DfSjv"};
styleInject(css_248z);

function defaultDataMapper(item) {
  switch (typeof item) {
    case "number":
      return { value: item, label: item.toString() };
    case "string":
      return { value: item, label: item };
    case "object":
      return item;
    default:
      return {};
  }
}
const defaultRenderItem = ({
  option,
  selected
}) => {
  return option && option.value && /* @__PURE__ */ React__default.createElement(
    SelectionListOption,
    {
      selected,
      value: option.value,
      "data-hook": option.value,
      onChange: () => true
    },
    option.label
  );
};
class SelectionList extends Component {
  constructor(props) {
    super(props);
    this.state = { focusIndex: -1 };
  }
  mapItemToOptionData(item) {
    const option = this.props.dataMapper(item);
    return {
      item,
      option,
      selected: option.value === this.props.value
    };
  }
  onKeyDown(event) {
    if (this.props.dataSource.length < 2) {
      return;
    }
    const index = this.state.focusIndex === -1 ? 0 : this.state.focusIndex;
    let nextIndex = -1;
    switch (event.key) {
      case "ArrowLeft":
      case "ArrowUp":
        nextIndex = index === 0 ? this.props.dataSource.length - 1 : index - 1;
        break;
      case "ArrowRight":
      case "ArrowDown":
        nextIndex = (index + 1) % this.props.dataSource.length;
        break;
      case "Tab":
        this.setState({ focusIndex: -1 });
        break;
      case " ":
      case "Enter":
        event.target.click();
        break;
    }
    if (nextIndex > -1) {
      this.setState({ focusIndex: nextIndex });
    }
  }
  render() {
    var _a, _b, _c;
    const { dataSource, className, onChange, renderItem, optionClassName } = this.props;
    const optionsData = dataSource.map((item) => this.mapItemToOptionData(item));
    const subText = (_c = (_b = (_a = optionsData.filter((optionData) => optionData.selected)) == null ? void 0 : _a[0]) == null ? void 0 : _b.item) == null ? void 0 : _c.subText;
    return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement(
      "div",
      {
        ref: (el) => this.ref = el,
        className: classNames(styles.selectionList, className),
        role: "listbox",
        "aria-orientation": "horizontal"
      },
      optionsData.map(({ item, option, selected }, i) => /* @__PURE__ */ React__default.createElement(
        SelectionListOption,
        {
          tabIndex: 0,
          selected,
          focused: i === this.state.focusIndex,
          dataHook: item.dataHook,
          onChange,
          key: i,
          value: option.value,
          optionClassName,
          onKeyDown: (e) => this.onKeyDown(e)
        },
        renderItem({ item, option, selected })
      ))
    ), subText && /* @__PURE__ */ React__default.createElement("div", { className: styles.selectionSubText }, " ", subText, " "));
  }
}
SelectionList.defaultProps = {
  dataMapper: defaultDataMapper,
  renderItem: defaultRenderItem
};
class SelectionListOption extends Component {
  componentDidUpdate() {
    var _a;
    if (this.props.focused) {
      (_a = this.ref) == null ? void 0 : _a.focus();
    }
  }
  render() {
    const { selected, onChange, children, value, dataHook, tabIndex, onKeyDown } = this.props;
    return /* @__PURE__ */ React__default.createElement(
      "div",
      {
        tabIndex,
        role: "option",
        "aria-selected": selected,
        ref: (el) => this.ref = el,
        onKeyDown: (e) => onKeyDown == null ? void 0 : onKeyDown(e),
        "data-hook": dataHook,
        onClick: () => onChange(value)
      },
      children
    );
  }
}

export { SelectionList as default };
//# sourceMappingURL=SelectionList.js.map
